import { render, staticRenderFns } from "./PropertyTable.vue?vue&type=template&id=be5b80da"
import script from "./PropertyTable.vue?vue&type=script&lang=js"
export * from "./PropertyTable.vue?vue&type=script&lang=js"
import style0 from "./PropertyTable.vue?vue&type=style&index=0&id=be5b80da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports